import { Link } from "react-router-dom";
import { Lock, Sparkles, ArrowRight } from "lucide-react";

/**
 * Shown when a trial user opens a category outside the three they unlocked.
 * Kept intentionally friendly — the goal is to convert, not scold.
 */
export default function TrialLockedNotice({ categoryName, trialCategories = [] }) {
  return (
    <div className="max-w-2xl mx-auto my-10 rounded-2xl bg-gradient-to-br from-[#0B0F0D] to-[#1a2420] border-2 border-[#D4AF37]/40 text-white p-8 sm:p-10 text-center shadow-xl"
      data-testid="trial-locked-notice">
      <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#D4AF37]/15 border border-[#D4AF37]/40 text-[#D4AF37] text-xs font-bold uppercase tracking-wider">
        <Lock className="w-3.5 h-3.5" /> Not in your trial
      </div>
      <h2 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight mt-4">
        {categoryName ? <>{categoryName} is unlocked with Pro</> : <>This category is unlocked with Pro</>}
      </h2>
      <p className="text-slate-300 mt-3 max-w-md mx-auto leading-relaxed">
        Your 24-hour pass covers three sample categories. To open every category — including this one — pick an annual plan or Lifetime.
      </p>
      {trialCategories.length > 0 && (
        <div className="mt-5 text-xs text-slate-400">
          <p className="uppercase tracking-wider font-bold text-slate-500">In your trial today</p>
          <p className="mt-1 text-slate-300">{trialCategories.join(" · ")}</p>
        </div>
      )}
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        <Link to="/pricing" data-testid="trial-locked-upgrade-btn"
          className="inline-flex items-center gap-2 bg-[#D4AF37] hover:bg-[#c9a233] text-[#0B0F0D] font-extrabold text-sm px-6 py-3 rounded-xl transition-colors">
          <Sparkles className="w-4 h-4" /> See plans <ArrowRight className="w-4 h-4" />
        </Link>
        <Link to="/categories" data-testid="trial-locked-back-btn"
          className="text-sm font-semibold text-slate-300 hover:text-white transition-colors">
          Back to categories
        </Link>
      </div>
    </div>
  );
}
